import e from "react";
import n from "classnames";
import { I as i } from "./Icon-BuIPTPJn.es.js";
import { T as l } from "./Tooltip-B-bmRvX4.es.js";
import { T as s } from "./index-Dd-4N6BE.es.js";
import './StaticIcon.css';const m = "StaticIcon-module__icon___g2UaH", _ = "StaticIcon-module__container___FNpid", d = "StaticIcon-module__label___kR7Kb", t = {
  icon: m,
  container: _,
  label: d
}, p = ({
  label: o,
  name: a,
  color: c = void 0,
  altColor: r = void 0
}) => /* @__PURE__ */ e.createElement("div", { className: t.container }, /* @__PURE__ */ e.createElement(
  l.Hover,
  {
    dark: !0,
    trigger: /* @__PURE__ */ e.createElement(
      i,
      {
        className: n(t.icon),
        name: a,
        size: 32,
        color: c,
        alt_color: r
      }
    ),
    placement: "top",
    accessible: !0,
    short: !0
  },
  /* @__PURE__ */ e.createElement("div", { className: t.label }, /* @__PURE__ */ e.createElement(s.Body2, { responsive: !0, darkBg: !0 }, o))
));
p.displayName = "StaticIcon";
export {
  p as S
};
